
// import lib from '@/library'
// import config from '@/config'
import Vue from 'vue'
import store from '@/store'
// import lib from '@/library'
import { i18n } from '@/library/locale/i18n'
import config from '@/config'
import rpcService from '@/library/rpcService'

const state = {
  savedBetsLoaded: false,
  deleteBetInProgress: false,
  config: {
    wishBet: config.app.autoconf.WISH_BET
  },
  wishBet: {
    os: 'Android',
    deviceId: '0123456789ABCDEF',
    authorization: null,
    storedBets: [],
    inProgress: false
  },
  ticketInfo: null,
  ticketInfoError: null
}

const getters = {
  wishBet (state) {
    return state.config.wishBet
  },
  wishBetDeviceId (state) {
    return state.wishBet.deviceId
  },
  wishBetOS (state) {
    return state.wishBet.os
  },
  wishBetAuthorizationToken (state) {
    return state.wishBet.authorization
  },
  wishBetStoredBets (state) {
    return state.wishBet.storedBets
  },
  wishBetInProgress (state) {
    return state.wishBet.inProgress
  },
  getSavedBetsLoaded (state) {
    return state.savedBetsLoaded
  },
  getDeleteBetInProgress (state) {
    return state.deleteBetInProgress
  },
  getTicketInfo (state) {
    return state.ticketInfo
  },
  getTicketInfoError (state) {
    return state.ticketInfoError
  }
}

const mutations = {
  setWishBetAuthToken (state, token) {
    // console.log('setWishBetAuthToken:', token)
    Vue.set(state.wishBet, 'authorization', token)
  },
  setWishBetStoredBets (state, betsArr) {
    Vue.set(state.wishBet, 'storedBets', betsArr)
  },
  setWishBetInProgress (state, bool) {
    Vue.set(state.wishBet, 'inProgress', bool)
  },
  setSavedBetsLoaded (state, data) {
    state.savedBetsLoaded = data
  },
  setDeleteBetInProgress (state, data) {
    state.deleteBetInProgress = data
  },
  setTicketInfo (state, data) {
    state.ticketInfo = data
  },
  setTicketInfoError (state, data) {
    state.ticketInfoError = data
  }
}

const actions = {
  initWishBet (context) {
    // console.log('initWishBet')
    if (!config.app.autoconf.WISH_BET) return
    context.dispatch('getWishBetAuthToken')
  },
  getDeviceOS (context) {
    return new Promise((resolve) => {
      let os = context.getters.wishBetOS
      resolve(os)
    })
  },
  getDeviceId (context) {
    return new Promise((resolve) => {
      let deviceId = context.getters.wishBetDeviceId
      resolve(deviceId)
    })
  },
  getDeviceData (context) {
    return context.dispatch('getDeviceOS').then(os => {
      return context.dispatch('getDeviceId').then(deviceId => {
        return {os, deviceId}
      })
    })
  },
  async getWishBetAuthToken (context, data) {
    rpcService.callBroker('wishbetclient', 'GetAuthToken', {
      'payload': data
    })
      .then(response => {
        if (response.result && !response.result.error && response.result.result) {
          context.commit('setWishBetAuthToken', response.result.result)
        }
      })
      .catch(error => {
        console.log('Error getWishBetAuthToken:', error)
      })
  },
  getWishBets (context) {
    // console.log('getWishBets')
    context.commit('setSavedBetsLoaded', false)
    rpcService.callBroker('wishbetclient', 'GetWishBets', {})
      .then(resp => {
        if (resp.result && (resp.result.result || !resp.result.error)) {
          // console.log(resp.result.result)
          if (resp.result.result) {
            resp.result.result.forEach(function (bet) {
              if (bet.idFoBetType === 'A' || (bet.idFoBetType).indexOf('A-') === 0) {
                let teasersPriceTypes = store.getters['sbBetslipState/teasersPriceTypes']
                let numOfLegs = 0
                let numOfTeamLegs = 0
                let lastLegSpread = 0
                let mixedTeasers = false
                let teaserLevel = 0
                if (bet && bet.betLegs) {
                  bet.betLegs.forEach(function (leg) {
                    numOfLegs++
                    if (teasersPriceTypes.includes(leg.IDFOPriceType)) {
                      numOfTeamLegs++
                      teaserLevel = leg.IDFOPriceType.slice(-1)
                      if (!mixedTeasers && lastLegSpread === 0) {
                        lastLegSpread = leg.Spread
                      }
                      if (lastLegSpread !== 0 && lastLegSpread !== leg.Spread) {
                        mixedTeasers = true
                        lastLegSpread = 0
                      }
                    }
                  })
                  if (numOfLegs >= 2 && numOfLegs === numOfTeamLegs) {
                    bet.BetTypeSpread = lastLegSpread ? (lastLegSpread >= 0 ? '+' : '-') + lastLegSpread : lastLegSpread
                    bet.TeaserLevel = teaserLevel
                    let spread = lastLegSpread ? (lastLegSpread >= 0 ? '+' : '-') + lastLegSpread + ' Spread' : 'Level ' + teaserLevel
                    bet.BetTypeExt = 'Teaser' + ' ' + spread + ': ' + numOfLegs + ' Legs'
                  } else if (numOfLegs >= 2) {
                    bet.BetTypeExt = 'Parlay: ' + numOfLegs + ' Legs'
                    if ((bet.idFoBetType).indexOf('A-') === 0) {
                      bet.BetTypeExt = bet.betTypeName + ': ' + numOfLegs + ' Legs'
                    }
                  } else {
                    bet.BetTypeExt = bet.betTypeName
                  }
                }
              }
            })
          }
          context.commit('setWishBetStoredBets', resp.result.result || [])
          context.commit('setSavedBetsLoaded', true)
        }
      })
  },
  getWishBetsConfig (context) {
    // console.log('getWishBets')
    return rpcService.callBroker('wishbetclient', 'GetConfig', {})
  },
  getWishBetsQuota (context) {
    // console.log('getWishBets')
    return rpcService.callBroker('wishbetclient', 'GetWishBetsQuota', {})
  },
  deleteWishBet (context, wishBet) {
    // console.log('deleteWishBet')
    context.commit('setDeleteBetInProgress', true)
    let hashedId = wishBet.hashedId
    rpcService.callBroker('wishbetclient', 'DeleteWishBet', {hashedId})
      .finally(() => {
        context.commit('setDeleteBetInProgress', false)
        context.dispatch('getWishBets')
      })
  },
  checkTicket (context, data) {
    rpcService.callBroker('checkticket', 'checkticket', {
      'barCode': data
    })
      .then(response => {
        if (response.result && !response.result.error && response.result.result) {
          console.log('wish - checkTicket response', response)
          context.commit('setTicketInfo', response.result.result)
          store.dispatch('overlayState/activateWishBetMsgDialog', { type: 'checkbet', content: response.result.result })
        } else if (response.result.error) {
          context.commit('setTicketInfoError', response.result.error.message)
          store.dispatch('overlayState/activateWishBetMsgDialog', { type: 'checkbet', content: response.result.error.message })
        }
      })
      .catch(error => {
        console.log('Error checkTicket:', error)
      })
  },
  storeWishBet (context) {
    // console.log('storeWishBet')
    store.commit('sbBetslipState/setCurrentBetSlipState', 1)
    context.commit('setWishBetInProgress', true)
    return store.dispatch('sbBetslipState/createBetSlip', {forWishBet: true})
      .then(function (betSlipObj) {
        // console.log(JSON.stringify(betSlipObj.betSlip.betSlip, null, 2))
        betSlipObj.isWishBet = true
        return store.dispatch('sbBetslipState/betSlipChecks', betSlipObj)
          .then(function () {
            let betSlip = (betSlipObj && betSlipObj.betSlip && betSlipObj.betSlip.betSlip) || {}
            betSlip = JSON.parse(JSON.stringify(betSlip))
            let xpInbound = (betSlipObj && betSlipObj.xpInbound) || []
            if (betSlip.Bets) {
              betSlip.Bets.forEach((bet, index) => {
                bet.xpInbound = xpInbound
                if (!bet.isSgpA) {
                  bet.xpInbound = [(xpInbound && xpInbound[index]) || null]
                }
                bet.TotalPrice = bet.price
                delete bet.price
                delete bet.isTeaser
                delete bet.IsPool
                delete bet.PlaceStake
                delete bet.ShowStake
                delete bet.IDFOMultiRacePool
                bet.SportType = bet.SportType || ''
                bet.BetLegs.forEach(leg => {
                  if (leg.SystemTag) {
                    leg.SystemTag += ''
                  }
                  delete leg.EachWayPlaceTerms
                  delete leg.EachWayReduction
                  delete leg.IDFOEventScorecast
                  delete leg.IsTrap
                  delete leg.LowerBand
                  delete leg.UpperBand
                })
              })
            }
            // console.log('storeWishBet betSlip:', betSlip)
            let results = []
            const saveBet = (bet) => {
              // bet.BetLegs = null
              return new Promise((resolve, reject) => {
                rpcService.callBroker('wishbetclient', 'SaveWishBet', {bet})
                  .then(result => {
                    // console.log('Saved bet')
                    results.push(result)
                    resolve(result)
                  })
                  .catch(error => {
                    console.log('store error:', error)
                    results.push({'result': {'result': null, 'error': {'code': 404, 'message': error}}})
                    resolve(false)
                  })
              })
            }
            async function processBets (maxQuota) {
              for (const bet of betSlip.Bets) {
                await saveBet(bet)
              }
              let requestBets = betSlip.Bets
              // console.log('All WishBets processed')
              //
              let successful = []
              let failed = []
              results.forEach((result, index) => {
                // console.log('Store WishBet response:', index, ':', result.result, '; request:', requestBets[index])
                if (result.result.error) {
                  requestBets[index].error = result.result.error
                  failed.push(requestBets[index])
                } else {
                  successful.push(result.result.result)
                }
              })
              store.commit('sbBetslipState/setCurrentBetSlipState', 0)
              let info = []
              if (successful.length) {
                // let barcode = successful[0].placementToken
                // store.dispatch('overlayState/activateWishBetMsgDialog', { type: 'barcode', content: barcode })
                //
                // successful.forEach((bet, index) => {
                  // info.push(bet.betTypeName + ' $' + bet.totalStake + (bet.error && bet.error.message ? '(' + bet.error.message + ')' : ''))
                // })
                info.push(i18n.t('WishBets.SuccessSavedBet' + (successful.length > 1 ? 's' : ''), {s: successful.length}))
                setTimeout(() => {
                  context.dispatch('getWishBets')
                }, 500)
              }
              if (failed.length) {
                /*
                let info = []
                failed.forEach((bet, index) => {
                  info.push(bet.betTypeName + ' $' + bet.totalStake + '<br>' + bet.error.message)
                })
                // info = info.join('\n')
                store.dispatch('overlayState/activateWishBetMsgDialog', { type: 'message', content: i18n.t('WishBets.FailedToSave') + info })
                */
                info.push(i18n.t('WishBets.FailedToSaveBet' + (failed.length > 1 ? 's' : ''), {f: failed.length}))
                if (failed[0] && failed[0].error && (failed[0].error.message || failed[0].error.code)) {
                  if (failed[0].error.code) {
                    info.push('(' + i18n.t('WishBet.Save.Error.' + failed[0].error.code, {q: maxQuota}) + ')')
                  } else {
                    info.push('(' + failed[0].error.message + ')')
                  }
                }
              }
              if (successful.length === 1 && !failed.length) {
                let barcode = successful[0].placementToken
                store.dispatch('overlayState/activateWishBetMsgDialog', { type: 'barcode', content: barcode })
              } else {
                if (successful.length) {
                  info.push('')
                  info.push(i18n.t('WishBets.BetsSaved.Info'))
                }
                info.push('<br>')
                store.dispatch('overlayState/activateWishBetMsgDialog', { type: 'message', content: info.join('<br>') })
              }
              context.commit('setWishBetInProgress', false)
            }
            //
            context.dispatch('getWishBetsQuota').then(r => {
              let q = (r && r.result && r.result.result) || {}
              let usedItems = q.usedItems || 0
              let allowedItems = q.allowedItems || 0
              if (usedItems && usedItems >= allowedItems) {
                store.commit('sbBetslipState/setCurrentBetSlipState', 0)
                context.commit('setWishBetInProgress', false)
                return store.dispatch('overlayState/activateWishBetMsgDialog', { type: 'message', content: i18n.t('WishBets.QuotaLimitReached', {q: allowedItems}) + '<br><br>' })
              }
              //
              let quotaWarning = context.rootGetters['sbBetslipState/wishBetSaveQuotaWarning']
              if (quotaWarning) {
                let betsN = (betSlip && betSlip.Bets && betSlip.Bets.length) || 0
                let availableN = allowedItems - usedItems
                if (betsN && betsN > availableN) {
                  store.commit('sbBetslipState/setCurrentBetSlipState', 0)
                  context.commit('setWishBetInProgress', false)
                  let info = []
                  info.push(i18n.t('WishBets.QuotaLimitReachedAlmost', {q: allowedItems, n: usedItems}))
                  info.push(i18n.t('WishBets.OverLimit' + (availableN > 1 ? 's' : ''), {q: availableN, b: betsN}))
                  info.push('<br>')
                  return store.dispatch('overlayState/activateWishBetMsgDialog', { type: 'message', content: info.join('<br>') })
                }
              }
              processBets(allowedItems)
            }).catch(err => {
              console.log('getWishBetsQuota err:', err)
              store.commit('sbBetslipState/setCurrentBetSlipState', 0)
              context.commit('setWishBetInProgress', false)
              let info = []
              info.push(i18n.t('WishBet.Save.Error.' + (err.status || '404')))
              info.push('<br>')
              return store.dispatch('overlayState/activateWishBetMsgDialog', { type: 'message', content: info.join('<br>') })
            })
          }).catch(function (errArr) {
            console.log('BetSlip Check Failed:', errArr)
            store.commit('sbBetslipState/setCurrentBetSlipState', 9)
            var data = {
              exceptionType: 'BetSlip.Check.Failed',
              betSlipCheckErrors: errArr,
              Status: {
                State: 4,
                DetailedState: 4,
                StatusCode: null,
                StatusText: 'BetSlip.Check.Failed',
                errorId: errArr,
                betSlipCheckError: true
              }
            }
            context.commit('setWishBetInProgress', false)
            return store.dispatch('sbBetslipState/processBetPlacementResult', [data, betSlipObj])
          }).finally(() => {
            // context.dispatch('getWishBets')
          })
      })
      .catch(err => {
        console.log('Error creating betslip:', err)
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

/*
WWishBet server errors
(401, "Unauthorized" )
(403, "Forbidden")
(404, $"Not Found {(itemId!=null ? $" {itemId}": string.Empty)}")
(422, $"Quota Limit Reached:{wishBetQuota.AllowedItems}")
(500, $"Server error")
*/



// WEBPACK FOOTER //
// ./src/store/modules/wishBets/wishBets.js